"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleLine = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _IntroText = require("../IntroText");

var _VerifiedUserOutlined = _interopRequireDefault(require("@material-ui/icons/VerifiedUserOutlined"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _validators = _interopRequireDefault(require("@jobmatchme/ui/es/utils/validators"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _Optimizers = require("../../utils/Optimizers");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SingleLineComponent = function SingleLineComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setValue(config.valueName, (0, _validators.default)(config.inputType)(value) ? value : '');
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputInvalid = _useState2[0],
      setInputInvalid = _useState2[1];

  var validateInput = function validateInput() {
    return setInputInvalid(!(0, _validators.default)(config.inputType)(context[config.valueName].value));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.TranslatedIntroText, {
      config: config
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.textField,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
        variant: "outlined",
        fullWidth: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
          htmlFor: "".concat(config.valueName, "-input"),
          className: _styleModule.default.label,
          children: t(config.translations.inputField)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
          onBlur: validateInput,
          error: inputInvalid,
          id: "".concat(config.valueName, "-input"),
          type: config.inputType || 'text',
          name: config.valueName,
          defaultValue: context[config.valueName].value,
          onChange: handleChange,
          label: t(config.translations.inputField),
          fullWidth: true,
          endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
            position: "end",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifiedUserOutlined.default, {
              color: "primary",
              className: _styleModule.default.icon
            })
          })
        }), inputInvalid && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.validationHelper,
          children: t(config.translations.helper)
        })]
      })
    })]
  });
};

var Wrapper = (0, _Optimizers.memoizeComponentByValue)(SingleLineComponent);

var SingleLine = function SingleLine(_ref2) {
  var config = _ref2.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    config: config,
    context: context
  });
};

exports.SingleLine = SingleLine;